import React from 'react';

import * as S from './styles';

const Slide4: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Subtitle>
        Alice usa jaqueta B.Luxo, R$ 1.580. Top, collab Bold Strap + Marcelo
        Bonito, R$ 2.900. Legging, Bold Strap, R$ 439.
        <br />
        <br />
        Em pé (na roda): top, Moun, R$ 439. Calça, Louis Vuitton, R$ 8 mil.
        Corset, collab Felipe Fanaia com UMS-480, R$ 590.
      </S.Subtitle>
    </S.Container>
  );
};

export { Slide4 };
